import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { config } from '../config/config';
import { setBaseUrl } from './ApiConfig';

const TENANT_STORAGE_KEY = 'selected_tenant';

class TenantService {
  private initialized = false;
  private activeTenantId: string | null = null;

  // No-op on web; on native reads the cached slug and activates the matching baseUrl.
  async initialize(): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      this.initialized = true;
      return;
    }
    const { value } = await Preferences.get({ key: TENANT_STORAGE_KEY });
    if (value && config.tenants[value]) {
      this.activeTenantId = value;
      setBaseUrl(config.tenants[value].baseUrl);
    }
    this.initialized = true;
  }

  async setTenant(tenantId: string): Promise<void> {
    const tenant = config.tenants[tenantId];
    if (!tenant) throw new Error(`Unknown tenant: ${tenantId}`);
    await Preferences.set({ key: TENANT_STORAGE_KEY, value: tenantId });
    this.activeTenantId = tenantId;
    setBaseUrl(tenant.baseUrl);
  }

  async clearTenant(): Promise<void> {
    await Preferences.remove({ key: TENANT_STORAGE_KEY });
    this.activeTenantId = null;
  }

  hasTenant(): boolean {
    return this.activeTenantId !== null;
  }

  isInitialized(): boolean {
    return this.initialized;
  }

  getActiveTenant(): { id: string; name: string; baseUrl: string } | null {
    if (!this.activeTenantId) return null;
    const tenant = config.tenants[this.activeTenantId];
    return tenant ? { id: this.activeTenantId, ...tenant } : null;
  }
}

export const tenantService = new TenantService();
export default tenantService;
